import React from 'react';
import { TextInput, StyleSheet, View, Text } from 'react-native';

const InputDefault = ({ value, editable = true, onValueChange, placeholder, type, ref }) => {
    return (
        <View style={styles.containerSocialContract}>
            <Text style={styles.description}>{placeholder}</Text>
            <TextInput
                editable={editable}
                style={[styles.TextInput, !editable ? { backgroundColor: "#eee", color: "#666" } : null]}
                value={value}
                onChangeText={(val) => onValueChange(val)}
                placeholder={placeholder}
                autoCapitalize="none"
                keyboardType={type !== undefined ? type : "default"}
                ref={ref}
            />
        </View>
    );
};

const styles = StyleSheet.create({
    TextInput: {
        width: 300,
        outlineStyle: 'none',
        padding: 10,
        borderWidth: 1,
        borderColor: "#000000",
        marginTop: 10,
        backgroundColor: "#fff",
        borderRadius: 4
    },
    containerSocialContract: {        
        paddingRight: 0,
        marginTop: 20
    },
    description: {
        textAlign: 'justify',
        fontSize: 14,
        fontWeight: '400',
        lineHeight: 15
    },
});
export default InputDefault;
